(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"]) return;
  try {
    
  
//     $(document).ready(function() {
//     var swiper = new Swiper(".cardSwiper", {
//         loop: true,
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//             dynamicBullets: true,
//         },
//         autoplay: {
//             delay: 2500,
        
//         }, 
//         navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//         breakpoints: {
//             481: {
//                 slidesPerView: 1,
//             },
//             600: {
//                 slidesPerView: 2,
//                 spaceBetween: 120,
//             },
//             1025: {
//                 slidesPerView: 4,
//                 spaceBetween: 120,
//             },
//             1280: {
//                 slidesPerView: 6,
//                 spaceBetween: 80                                                                                                                                      0,
//             },
//         }
//     });
// });
  

var swiper = new Swiper(".cardSwiper", {
    // slidesPerView: 6,
    // spaceBetween: 30,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
    },
    autoplay: {
        delay: 2000,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 2,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 80,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 80,
        },
        1280: {
            slidesPerView: 6,
            spaceBetween: 60,
        },
    }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-product-slider"]) return;
  try {
    
  var swiper = new Swiper(".cardBoxSwiper", {
    spaceBetween: 25,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      481: { slidesPerView: 1 },
      600: { slidesPerView: 2, spaceBetweenSlides: 20 },
      1025: { slidesPerView: 3, spaceBetweenSlides: 20 },
      1280: { slidesPerView: 4, spaceBetweenSlides: 25 }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-gallery"]) return;
  try {
    
  jQuery(document).ready(function($) {
      $('.modal-form').on('click', function(e){        
          let _href = $(this).attr("href");
          if(!$(_href) == ""){
               e.preventDefault();
              $('#app-embed-container-29367 button[data-testid="teaser-container"]').trigger('click');   
          }
      });
  });
  var swiper = new Swiper(".gallery_slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-old"]) return;
  try {
    
  

const addCompareButtons = document.querySelectorAll('.add_compare');
addCompareButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        const customContent = this.closest(".custom_content");
        const checkbox = customContent.querySelector('input[type="checkbox"]');
        checkbox.click();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Optional helper you had; safe to keep.
  const addCompareButtons = document.querySelectorAll('.add_compare');
  addCompareButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const customContent = this.closest(".custom_content");
      const checkbox = customContent ? customContent.querySelector('input[type="checkbox"]') : null;
      if (checkbox) checkbox.click();
    });
  });
  // Removed previous "View More" jQuery; server-side {% paginate %} controls items per page now.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"]) return;
  try {
    
// console.log("Before Swiper Initialization");
var swiper = new Swiper(".bannerSwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
});
// console.log("After Swiper Initialization");

  




  } catch(e) { console.error(e); }
})();
})();
